var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading",style:({ padding: _vm.pad ? (_vm.pad + "px") : '50px' })},[_c('EllipsisLoader',{attrs:{"color":"#656ef1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }